 <template>
    <v-dialog v-model="editorShownFlight" width="850">
        <!-- Begin:Content:Mode:update ------------------------------------- -->
        <v-card v-if="editorMode === 'update'" style="border: 2px solid green;">
            <v-card-title class="grey lighten pa-5" style="color: white; font-size: 15px;  font-weight: 500;">
                <i style="font-size:20px; color: green;" class="b-fa b-fa-user-friends"></i>&nbsp;&nbsp;{{ this.eventName || '&nbsp;' }} COMMENTS ({{ editorMode.toUpperCase() }})
            </v-card-title>

            <v-card-text class="pa-5">
                <comment-textarea v-model="dutyComment" label="Flight Comment:" maxlength="300" />
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
                <div class="flex-grow-1"></div>
                <v-btn style="width:120px; font-size:12px;" depressed elevation="1" outlined color="#ab3b7a" @click="editorShownFlight = false">Cancel</v-btn>
                <v-btn style="width:120px; font-size:12px;" depressed elevation="1" color="primary" @click="onSave_FlightUpdate">Save</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import CommentTextarea from '../../CommentTextarea.vue';

    import { mapGetters, mapActions } from 'vuex';
    import { eventBus } from '../../../../../../../main';


    export default {
        name  : 'event-editor-flight',

        /* >>> *************************************************************** / /* Props */
        props : {

            value           : [ Boolean, Object ],                              // editorShownFlight
            eventStore      : Object,                                           // 'update'
            resourceId      : [ String, Number ],                               // 'update'
            eventRecord     : Object,                                           // 'update'
            resourceRecord  : Object,                                           // 'create'
            addDate         : Date,                                             // 'create'
            eventName       : String,                                           // 'update', 'create'
            editorMode      : String,                                           // 'update', 'create'

        }, // eo props{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Components */
        components : {

            CommentTextarea,

        }, // eo components{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data: () => ({

            // >>> ------------------------------
            startDate       : null,
            endDate         : null,
            // >>> ------------------------------
            dutyComment     : null,
            // >>> ------------------------------

        }), // eo fucntion data()
        /* <<< ****************************************************************/




        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'get_Airports',
            ]),


            /*******************************************************************
            * editorShownDayoff()
            *
            * Desc:
            * Note: Distinguishes between editorMode: 'update', 'create'
            *
            */
            editorShownFlight: {

                /***************************************************************
                * get()
                *
                * Note: Distinguishes between editorMode: 'update', 'create'
                * Note: Set '23:59' to Create endDate.
                *
                */
                get() {

                    let me = this,
                        eventRecord = me.eventRecord;


                    me.$toc('>>> views/crewplanning/crewcalendar/components/editevents/flight/EventEditor.vue >>> editorShownFlight get');
                    if (true === me.value) {                                    // we're opening so initialize data

                        // >>> ------------------ update
                        if (this.editorMode === 'update') {
                            if (eventRecord) {
                                Object.assign(me, {
                                    eventName       : this.eventName, // eventRecord.name,
                                    dutyComment     : eventRecord.dutyComment
                                });
                            }
                        }

                    } else if (false === me.value) {                            // we're closing so fire close event
                        // this.$emit('close'); // Needed?
                    }

                    // return always Boolean
                    return !!this.value;

                }, // eo editorShownFlight get()

                /***************************************************************
                * set()
                *
                * Desc:
                * Note: only runs on close.
                *
                */
                set(value) {

                    let me = this;;


                    me.$toc('>>> views/crewplanning/crewcalendar/components/editevents/flight/EventEditor.vue >>> editorShownFlight set');
                    this.$emit('input', value);

                } // eo editorShownFlight set()

            } // eo function editorShownFlight()

        }, // eo computed{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc: Listen to 'updateflightcomment'.
        * Note: Runs after the instance is created. Installs Listeners.
        *
        */
		created: function () {

            let me = this;


            me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/flight/EventEditor.vue >>> created');
            eventBus.$on('updateflightcomment', this.onUpdate_FlightComment); // call: modify single duty successful

        }, // eo function created()


        /***********************************************************************
        * Lifecyclehook::beforeDestroy
        *
        * Desc: Destroy Listener.
        * Note:
        *
        */
        beforeDestroy: function() {

            let me = this;


            me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/flight/EventEditor.vue >>> beforeDestroy');
            eventBus.$off('updateflightcomment', this.onUpdate_FlightComment);

        }, // eo function beforeDestroy()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            ...mapActions([
                'actn_update_FlightComment', // Call: Modify Flights Comment
            ]),


            /******************************************************************* 'Listeners - Common'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * onSave_FlightUpdate()
            *
            * Desc: Save Handler - 'UPDATE'.
            * Note: Tooltip is in 'note'.
            * Note: Calling this method updates also duration (resizes the event)
            *
            */
            onSave_FlightUpdate: function(){

                let me = this,
                    params = {};


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/flight/EventEditor.vue >>> onSave_FlightUpdate');
                // >>> -------------------------- params
                params = {
                    idFlights: [me.eventRecord.originalId],
                    dutyComment: me.dutyComment !== '' ? me.dutyComment : null
                };


                // >>> -------------------------- validate
                if (this.validateParams(params) === true) {
                    this.actn_update_FlightComment(params);
                }

            }, // eo function onSave_FlightUpdate()




            /******************************************************************* 'Listeners - eventBus'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * onUpdate_FlightComment()
            *
            * Desc: Successful Call => emits 'updateflightcomment' Event.
            * Desc: Change Data in Scheduler.
            * Note: NOT (!) Using Response of Call:'' for buildEventNote.
            * Note: Bypass missing Call Response?
            *
            * @param {Object} response (Response from Call)
            */
            onUpdate_FlightComment: function(response){

                let me = this,
                    style = null,
                    tooltipData = null;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/flight/EventEditor.vue >>>  onUpdate_FlightComment');
                // me.eventRecord.setStartEndDate(me.startDate, me.endDate);
                // me.eventRecord.set({ idApt: me.idApt });
                // me.eventRecord.set({ aptCode: me.aptCode });
                me.eventRecord.set({ dutyComment: response.dutyComment });

                response.type = 'FLIGHT';
                tooltipData = me.$buildEventNote(response); // Catch after 'requested was set!: Important
                me.eventRecord.set({ nameEvent: tooltipData.nameEvent });
                me.eventRecord.set({ note: tooltipData.note });

                // >>> Style ----------------------------------------
                if (response.dutyComment !== null) {
                    if (me.eventRecord.style !== null) {
                        style = me.eventRecord.style  + ' border-right: 3px dotted #000;';
                    } else {
                        style = ' border-right: 3px dotted #000;';
                    }
                }
                me.eventRecord.set({ style: style });
                // <<< Style ----------------------------------------


                // >>> close the editor .. now ----------------------
                me.editorShownFlight = false;

            }, // eo function onUpdate_FlightComment()




            /*******************************************************************
            * Validators:
            *******************************************************************/
            /*******************************************************************
            * validateParams()
            *
            * Desc: Checks/Validates Params before send to Backend.
            * Note: Kind if cascading Validations.
            * Note:
            *
            * @param {Object} params (Params we want to send)
            */
            validateParams: function(params) {

                let me = this,
                    valid = true;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/flight/EventEditor.vue >>>  validateParams');


                return valid;

            }, // eo function validateParams()

        }, // eo methods{}
        /* <<< ****************************************************************/

    };
</script>
